export default __webpack_public_path__ + "static/media/tete85.8bde53ae.png";